export default "__VITE_ASSET__b0cb45cf__"